import { CircularProgress } from '@mui/material';
import styled from 'styled-components';

import { FC } from 'react';
import { fadeIn, FlexAlignCenterJustifyCenter } from '../../styles/styles';

type LoadingScreenProps = {
	fullScreen?: boolean;
};

export const LoadingScreen: FC<LoadingScreenProps> = ({ fullScreen }) => {
	return (
		<Wrap fullScreen={fullScreen}>
			<CircularProgress size={70} color="inherit" />
		</Wrap>
	);
};

const Wrap = styled.div<{ fullScreen?: boolean }>`
	height: ${({ fullScreen }) => (fullScreen ? '100vh' : '100%')};
	animation: ${fadeIn} 0.4s;
	${FlexAlignCenterJustifyCenter};
`;
